import { API } from "aws-amplify";
import { filterByOwner, findById } from "@/helpers";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    locationsByOwner: (state) => {
      return (id) => {
        const location = filterByOwner(state.items, id);
        if (!location) return null;
        return {
          ...location,
        };
      };
    },
    location: (state) => {
      return (id) => {
        const location = findById(state.items, id);
        if (!location) return null;
        return {
          ...location,
        };
      };
    },
  },
  actions: {
    async getLocations({ commit }) {
      const results = await API.graphql({
        query: queries.listLocations,
      });

      commit("setLocations", results.data.listLocations.items);
    },
    async createLocation({ dispatch, rootState }, data) {
      if (!rootState.auth.authUser) return;
      await API.graphql({
        query: mutations.createLocation,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      //STATEの更新
      dispatch("getLocations");
      const message = "住所を追加しました";
      dispatch("utils/openSnackbar", message, { root: true });
    },
    async updateLocation({ dispatch, rootState }, data) {
      if (!rootState.auth.authUser) return;
      await API.graphql({
        query: mutations.updateLocation,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      //STATEの更新
      dispatch("getLocations");
      const message = "保存しました";
      dispatch("utils/openSnackbar", message, { root: true });
    },
    async deleteLocation({ dispatch }, { id }) {
      const data = {
        id: id,
      };
      await API.graphql({
        query: mutations.deleteLocation,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      //STATEの更新
      dispatch("getLocations");
      const message = "削除しました";
      dispatch("utils/openSnackbar", message, { root: true });
    },
  },
  mutations: {
    setLocations(state, locations) {
      state.items = locations;
    },
  },
};
